import { useRef, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

export default function FileDropZone({ onFileSelect }) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFiles = (files) => {
    if (!files || files.length === 0) return;
    const file = files[0];
    onFileSelect?.(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (e) => {
    handleFiles(e.target.files);
  };

  return (
    <Box
      onClick={handleClick}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      sx={{
        border: "2px dashed",
        borderColor: dragActive ? "primary.main" : "#ccc",
        borderRadius: 2,
        p: 4,
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.2s ease",
        bgcolor: dragActive ? "rgba(25,118,210,0.05)" : "#fafafa",
        "&:hover": {
          borderColor: "primary.main",
          bgcolor: "rgba(25,118,210,0.05)",
        },
      }}
    >
      {/* Icon */}
      <CloudUploadOutlinedIcon
        sx={{
          fontSize: 40,
          color: "primary.main",
          mb: 1,
        }}
      />

      {/* Title */}
      <Typography variant="subtitle1" fontWeight={500}>
        Drag & drop files here
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 0.5, mb: 2 }}
      >
        Upload your completed template to validate and register multiple
        businesses at once.
      </Typography>

      <Button
        variant="outlined"
        size="small"
        onClick={(e) => {
          e.stopPropagation(); // prevent triggering parent click twice
          handleClick();
        }}
        sx={{ textTransform: "none", borderRadius: 1 }}
      >
        Browse files
      </Button>

      <input
        ref={inputRef}
        type="file"
        hidden
        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={handleChange}
      />
    </Box>
  );
}
